
export class MapModel {

  public center: { lat: number, lng: number } = { lat: 0, lng: 0 };

  constructor(model?: Partial<MapModel>) {
    if (model?.center) this.center = { ...model.center };
  }
}
